module.exports = __webpack_public_path__ + "img/logo.ce3eef52.png";